import { encode as base64_encode } from 'base-64';
import { postApi } from '../components/Utility'
import {
  action,
  makeObservable,
  observable,
} from 'mobx';
import config from "../config";

class VehicleDistanceStore {
  vehicleDistanceVehicles = []
  total = 0
  loading = false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
      vehicleDistanceVehicles: observable,
      loading: observable,
      total: observable,
      loadData: action,
      addData: action,
      getVehicleDistanceData: action,
      deleteRecord: action

    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit, currentPage }) {
    let response
    this.loading = true

    if (config.pythonReport === 1) {
      const queryParams = {
        companyId: companyId,
        offset: offset,
        limit: limit,
        page: currentPage,
      };
      response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/vehicleDistance/getVehicleDistance", {
          params: queryParams,
        });
    } else {
      var postData = { "companyId": companyId, "offset": offset, "limit": limit, "page": currentPage }

      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=manualdistance&a=manualDistanceList", "postData=" + base64Input);
    }

    this.vehicleDistanceVehicles = response?.data?.data?.manualDistance
    this.total = parseInt(response?.data?.data?.TotalCount)
    this.loading = false
  }

  async addData(vehicledistance) {
    let response
    if (config.pythonReport === 1) {
      response = await postApi
        .getClient("")
        .post(
          config.NodeUrl + "/vehicleDistance/saveVehicleDistance",
          vehicledistance
        );
    } else {
      var postData = vehicledistance
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=manualdistance&a=update", "postData=" + base64Input);
    }
    return response
  }

  async getVehicleDistanceData(mid) {
    let response
    var postData = { "mid": mid, offset: 0, limit: 1 }

    if (config.pythonReport === 1) {
      response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/vehicleDistance/getVehicleDistance", {
          params: postData,
        });
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=manualdistance&a=manualDistanceList", "postData=" + base64Input);
    }
    return response?.data?.data?.manualDistance[0]
  }

  async deleteRecord({ manualDistanceId }) {
    let response
    if (config.pythonReport === 1) {
      response = await postApi
        .getClient("")
        .delete(
          config.NodeUrl +
          "/vehicleDistance/deleteVehicleDistance?manualDistanceId=" +
          manualDistanceId
        );
    } else {
      var postData = { "manualDistanceId": manualDistanceId }
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=manualdistance&a=delete", "postData=" + base64Input);
    }
    return response;
  }
}

export default VehicleDistanceStore;
